// src/views/APropos/APropos.js
import cv from "../../assets/vs-logo2.png";
import CollapseItem from "../../components/Collaps/Collaps";
import "./APropos.scss";

function APropos() {
  return (
    <div>
      <main>
        <div className="cv-container">
          <a
            href="/Sabouroux_Valerie_CV_072726.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={cv} alt="QR code vers mon CV" className="cv-image" />
          </a>
        </div>
        <p className="CV">
              Mon CV est accessible en cliquant sur le QR code ci-dessus
        </p>
        <div className="container">
          <div className="APropos">
            <p className="valeurs">
              Voici les valeurs qui guident mon action au quotidien
            </p>
            <CollapseItem
              title="Innovation"
              content="Porter une attention continue aux évolutions, transformations, disruptions qui s'opèrent dans l'environnement. C'est aussi l'adaptation des ressources et des savoir-faire aux évolutions
               pour l'enrichissement continu des missions."
            />
            <CollapseItem
              title="Respect"
              content="Respecter ses engagements envers ses ressources (qu’elles soient salariées ou non), ses clients, ses fournisseurs et autres partenaires. C'est aussi
              développer un comportement loyal envers ces mêmes acteurs, adopter en toutes circonstances une attitude honnête."
            />
            <CollapseItem
              title="Adaptation"
              content="Mobiliser en un minimum de temps les bonnes ressources au service du projet du client. C'est aussi être capable de se remettre réellement en cause, d'anticiper les transformations,
            et d'intégrer au projet les innovations qui apporteront de la valeur. Cette capacité d'adaptation demande de développer une vision end to end. " 
            />
          </div>
        </div>
      </main>
      {/* <Footer /> */}
    </div>
  );
}
export default APropos;
